import { logVerboseUsage } from 'owa-analytics';
import type { LayoutChangeSource } from 'owa-layout';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export default async function logFolderPaneState(
    layoutChangeSource: LayoutChangeSource,
    folderPaneNewShowState: boolean,
    folderPaneOldShowState: boolean
): Promise<void> {
    logVerboseUsage('TnS_FolderPaneChange', getGlobalSettingsAccountMailboxInfo(), [
        layoutChangeSource.toString(),
        folderPaneNewShowState,
        folderPaneOldShowState,
    ]);
}
